import React, {useEffect, useState} from 'react';
import { NavLink } from 'react-router-dom';

function ShowContacts({ contacts, getNext}) {
 const[con, setCon] = useState([])
 const[first, setFirst] = useState(0)
 const[second, setSecond] = useState(10)
  
  useEffect(() => {
    setCon(contacts.slice(first, second))
  }, [contacts, first, second])


    return (
    <div className="flex flex-col">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Name
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    LinkedIn
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Role
                  </th>
                  <th scope="col" className="relative px-6 py-3">
                    <span className="sr-only">Details</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {con?.map((contact, index) => (
                  <tr key={index} value={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    <td className="px-6 py-4 whitespace-pre-line text-sm font-medium text-gray-900">{contact.ProspectName}</td>
                    <td className="px-6 py-4 whitespace-pre-line text-sm text-gray-500">{contact.Linkedin}</td>
                    <td className="px-6 py-4 whitespace-pre-line text-sm text-gray-500">{contact.ProspectRole}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <NavLink
                      key={index}
                      exact
                      to={'/contact/' + contact.id}
                      style ={{textDecoration:'none'}}
                      >
                        <button 
                          className="text-indigo-600 hover:text-indigo-900"
                        >
                          Details
                        </button>
                      </NavLink>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <nav
              className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
              aria-label="Pagination"
            >
              <div className="hidden sm:block">
                {contacts.length < 10 ? null :
                <p className="text-sm text-gray-700">
                    Showing <span className="font-medium">{first+1}</span> to <span className="font-medium">{second}</span> of{' '}
                  <span className="font-medium">{contacts.length}</span> results
                </p>}
              </div>
              <div className="flex-1 flex justify-between sm:justify-end">
                {first <=0 ? null :
                <button
                  type="button"
                  className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                  onClick={()=>{setFirst(first-10); setSecond(second-10)}}
                >
                  Previous
                </button>}
                {second >= contacts.length ? null :
                <button
                  type="button"
                  className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                  //onClick={()=>getNext()}
                  onClick={()=>{setFirst(first+10); setSecond(second+10)}}
                >
                  Next
                </button>}
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
    )
}

export default ShowContacts